export const toHttpUrl = (url: string): string => {
  if (!url) return url;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("gs://")) {
    const withoutScheme = url.slice(5);
    const slashIndex = withoutScheme.indexOf("/");
    if (slashIndex === -1) return url;
    const bucket = withoutScheme.slice(0, slashIndex);
    const objectPath = withoutScheme.slice(slashIndex + 1);
    return `https://storage.googleapis.com/${bucket}/${encodeURI(objectPath)}`;
  }
  return url;
};
